import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import Color from '@/utils/color';

type CheckboxContainerProps = {
  vytalStyle: boolean;
  disabled: boolean;
};

const CheckboxContainer = styled.div<CheckboxContainerProps>`
  border: 1px solid ${({ theme }) => (theme as any).color.primary};
  border-radius: 4px;
  width: 17px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) =>
    props.vytalStyle
      ? `
    background-color: white;
    border: 1px solid ${Color.VytalGreyBorder};
    color: ${Color.VytalGrey};
  `
      : ''}
  ${(props) =>
    props.disabled
      ? `
    opacity: 0.15;
    pointer-events: none;
  `
      : ''}
`;

const StyledIcon = styled.div`
  color: ${({ theme }) => (theme as any).color.primary};
  width: 100%;
  height: 100%;
  font-size: 1rem;
`;

type CheckboxProps = {
  checked: boolean;
  disabled?: boolean;
  vytalStyle?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
};

function Checkbox({
  checked,
  onClick,
  disabled = false,
  vytalStyle = false,
}: CheckboxProps) {
  return (
    <CheckboxContainer
      onClick={onClick}
      disabled={disabled}
      vytalStyle={vytalStyle}
    >
      {checked && (
        <StyledIcon>
          <Icon name="check" />
        </StyledIcon>
      )}
    </CheckboxContainer>
  );
}

export default Checkbox;
